import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Access } from '@prisma/client';
import { Space, Tag, Typography } from 'antd';

export type IemAccessNameRendererProps = {
  iemAccess: Access;
};
export const IemAccessNameRenderer = ({ iemAccess }: IemAccessNameRendererProps) => {
  const { name, isActive } = iemAccess;
  return (
    <Space size="small" direction="vertical">
      <Typography.Text>{name}</Typography.Text>
      {!isActive && (
        <Tag icon={<ExclamationCircleOutlined />} color="error">
          Not found in IEM, likely moved to AGS
        </Tag>
      )}
    </Space>
  );
};
